// extracted by mini-css-extract-plugin
export default {"name_page":"InputPhoneModal_name_page__pNESI","item_input":"InputPhoneModal_item_input__NzBYd","btn_logout":"InputPhoneModal_btn_logout__IJ5hb"};